// @flow
import React from "react";
import type { FlagContentProps } from "../types";

const France = ({ circular }: FlagContentProps) =>
  circular ? (
    <React.Fragment>
      <g clipPath="url(#clip0_3_5)">
        <path d="M15.4097 0H4.56734V20H15.4097V0Z" fill="#F8F8F9" />
        <path
          d="M-5.95417 0H-6V20H-5.95417H4.56733V0H-5.95417Z"
          fill="#2959A3"
        />
        <path d="M15.4327 0V20H26V0H15.4327Z" fill="#DE3131" />
      </g>
      <defs>
        <clipPath id="clip0_3_5">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <g clipPath="url(#clip0_2_1512)">
        <path d="M21.4097 0H10.5673V20H21.4097V0Z" fill="#F8F8F9" />
        <path
          d="M0.0458341 0H0V20H0.0458341H10.5673V0H0.0458341Z"
          fill="#2959A3"
        />
        <path d="M21.4327 0V20H32V0H21.4327Z" fill="#DE3131" />
      </g>
      <defs>
        <clipPath id="clip0_2_1512">
          <rect width="32" height="20" rx="2" fill="white" />
        </clipPath>
      </defs>
    </React.Fragment>
  );

// $FlowFixMe
export default React.memo(France);
